import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";

// Shared components
import { Navigation } from "./components/shared/Brand";
import ScrollToTop from "./components/shared/ScrollToTop";
import SEO from "./components/shared/SEO";

// Home page components
import {
  HeroSection,
  MetricsBar,
  StartHereSection,
  CalculatorTeaser,
  AboutSection,
  TestimonialsSection,
  InsightsTeaser,
  ContactSection,
  ExperienceSection,
  LRSSection,
  BuilderSection,
  Footer
} from "./components/home";

// Page imports
import GuidebookPage from "./pages/Guidebook";
import SDREconomicsPage from "./pages/SDREconomics";
import ResourcesPage from "./pages/Resources";
import TalentPoolPage from "./pages/TalentPool";
import ServicesPage from "./pages/Services";
import ResultsPage from "./pages/Results";
import ApproachPage from "./pages/Approach";
import InsightsPage from "./pages/Insights";
import AISDRPlaybookPage from "./pages/AISDRPlaybook";

const HomePage = () => (
  <div className="min-h-screen bg-[#0A0A0A]">
    <SEO 
      title="Dan Leitner | Sales Development & GTM Leader"
      description="Dan Leitner builds sales development organizations that create pipeline, develop future AEs, and scale. Head of Sales Development | Pipeline Growth | GTM | AI-Enabled Outbound."
      path="/"
      image="home"
    />
    <Navigation />
    <HeroSection />
    <MetricsBar />
    <ExperienceSection />
    <BuilderSection />
    <AboutSection />
    <StartHereSection />
    <TestimonialsSection />
    <InsightsTeaser />
    <CalculatorTeaser />
    <LRSSection />
    <ContactSection />
    <Footer />
  </div>
);

// Main App with Router
function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/approach" element={<ApproachPage />} />
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/resources/ai-sdr-guidebook" element={<GuidebookPage />} />
          <Route path="/resources/ai-sdr-playbook" element={<AISDRPlaybookPage />} />
          <Route path="/resources/sdr-economics" element={<SDREconomicsPage />} />
          <Route path="/resources/talent-pool" element={<TalentPoolPage />} />
          <Route path="/talent" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
